import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.depots')
  .factory('$depots', depotsObjectFactory);

/* @ngInject */
function depotsObjectFactory($bringozFactory: $bringozFactory,
                             depotsAPI: BringozApi,
                             Depots_DS: DataStoreConfig) {

  function $depots(id: string) {
    return $bringozFactory(id, depotsAPI, Depots_DS);
  }
  return $depots;
}
